import {SagaIterator} from "redux-saga";
import {call, takeEvery, getContext} from "redux-saga/effects";
import {Action} from "typescript-fsa";
import {bindAsyncAction} from "typescript-fsa-redux-saga";
import {IceClient, tokenRefreshed} from "@neolab/ice-client";

import "@slices/Ganymede/Glacier";
import {Permissions} from "@slices/Permissions/Permissions";
import {knownPermissions} from "src/services/permissions";

import {loadUser} from "./iceClient.actions";


const loadUserWorker = bindAsyncAction(loadUser)(
  function* loadUserWorker({token}): SagaIterator {
    const iceClient: IceClient = yield getContext('iceClient');
    const permissionsPrx: Permissions.PermissionsServicePrx =
      yield call(iceClient.getProxy, 'Permissions');

    return yield call(permissionsPrx.getPrincipal, token, knownPermissions);
  },
);



export default function* iceClientSaga(): SagaIterator {
  const iceClient: IceClient = yield getContext('iceClient');

  yield takeEvery(tokenRefreshed.type,
    (action: Action<{token: string}>) => loadUserWorker(action.payload));

  yield call(iceClient.saga, {
    beforeSession(token: string) {
      return loadUserWorker({token});
    },
  });
}



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/sagas/iceClient.ts